// extracted by mini-css-extract-plugin
module.exports = {"liveNowIcon":"qIrWP"};